/** Whether the crew comfort & compliance panel (Form 9) is open. Escape toggles it anywhere. */
class Menu { open = $state(false); }
export const menu = new Menu();
